module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "situation-absences h-100"
  }, [_c('span', {
    staticClass: "h-100",
    class: _vm.isModeManager ? 'd-block' : 'd-none'
  }, [_c('situation-manager', {
    attrs: {
      "dataReady": _vm.dataReady,
      "isModeManager": _vm.isModeManager,
      "listeCompteursAbsencesEquipe": _vm.listeCompteursAbsencesEquipe,
      "anneeCouranteConges": _vm.anneeCouranteConges
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "h-100",
    class: _vm.isModeManager ? 'd-none' : 'd-block'
  }, [_c('situation-salarie', {
    attrs: {
      "dataReady": _vm.dataReady,
      "compteurAbsences": _vm.compteurAbsences,
      "anneeCouranteConges": _vm.anneeCouranteConges
    },
    on: {
      "paieEnable": _vm.paieEnableChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a16c83c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsences/situationDesAbsences/situationDesAbsences.vue.html
// module id = 7NTz
// module chunks = 2